import React from 'react';
import styled from 'styled-components';
import Sidebar from './Sidebar';
import { useAuth } from '../contexts/AuthContext';

const LayoutContainer = styled.div`
  display: grid;
  grid-template-columns: 280px 1fr;
  min-height: 100vh;
  background: #f5f7fa;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ContentArea = styled.div`
  overflow-y: auto;
`;

const Layout = ({ children }) => {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <LayoutContainer>
      <Sidebar user={user} onLogout={handleLogout} />
      <ContentArea>
        {children}
      </ContentArea>
    </LayoutContainer>
  );
};

export default Layout;
